import { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Login from "./pages/login/login";
import Signup from "./pages/signup/signup";
import StartupApplicationForm from "./pages/form/form";
import ProtectedRoute from "./components/ProtectedRoute";
import { useAuth } from "./context/AuthContext";

function App() {
  const { bootstrap } = useAuth();

  // Restore session on app load (uses refresh cookie)
  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  return (
    <div className="app-layout">
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          {/* Protected — must be logged in */}
          <Route
            path="/form"
            element={
              <ProtectedRoute>
                <StartupApplicationForm />
              </ProtectedRoute>
            }
          />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;